module.exports = __webpack_public_path__ + "static/media/close.933fa1da.svg";